import { Reveal } from "./Reveal";

const PORTRAIT_IMG = "/assets/foto-1984.webp";

export default function Begleitung() {
  return (
    <section data-testid="trust-section" className="bg-cream px-6 md:px-14 py-20 md:py-28">
      <div className="max-w-6xl mx-auto grid md:grid-cols-[1fr_1.2fr] gap-16 md:gap-24 items-center">
        <Reveal>
          <div className="relative mx-auto w-full max-w-sm md:max-w-none">
            <div className="absolute -inset-3 translate-x-5 translate-y-5 rounded-md border border-gold/50" aria-hidden="true" />
            <div className="relative overflow-hidden rounded-md">
              <img
                data-testid="trust-portrait"
                src={PORTRAIT_IMG}
                alt="Nicole Schüssler, Praxis einfach glücklich"
                className="aspect-[4/5] w-full object-cover object-[50%_22%] transition-transform duration-700 ease-out hover:scale-[1.03]"
              />
            </div>
            <p className="mt-5 text-xs uppercase tracking-[0.24em] text-taupe">
              Nicole Schüssler · Praxis «einfach glücklich»
            </p>
          </div>
        </Reveal>

        <div>
          <Reveal>
            <p className="text-xs md:text-sm font-medium uppercase tracking-[0.32em] text-bronze mb-6">
              Deine Begleitung
            </p>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="font-serif tracking-tight text-2xl md:text-4xl leading-tight text-espresso">
              Du darfst dich fallen lassen. <span className="italic text-bronze">Ich begleite dich.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mt-8 text-base md:text-lg font-light leading-relaxed text-taupe">
              Ich bin Nicole Schüssler, dipl. zert. Hypnosetherapeutin und begleite
              Menschen in meiner Praxis «einfach glücklich» mit Hypnose und
              Hypnomeditation.
            </p>
            <p className="mt-5 text-base md:text-lg font-light leading-relaxed text-taupe">
              Für mich bedeutet Hypnose nicht, dir etwas „wegzumachen“. Ich schaffe
              einen geschützten Rahmen, in dem du für einen Moment nicht
              funktionieren, nichts beweisen und nichts erklären musst.
            </p>
            <p className="mt-5 text-base md:text-lg font-light leading-relaxed text-taupe">
              Du bestimmst jederzeit selbst, wie weit du dich auf die Hypnomeditation
              einlassen möchtest.
            </p>
          </Reveal>
          <Reveal delay={0.24}>
            <p className="mt-10 font-serif italic text-xl md:text-2xl text-espresso">
              «Loslassen ist kein Verlieren – es ist ein Freiwerden.»
            </p>
            <p className="mt-3 text-sm font-light text-taupe">Nicole Schüssler</p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
